import axios from 'axios'
import router from '@/router'  // ✅ useRouter() 대신 이거 사용

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, error => Promise.reject(error));

api.interceptors.response.use(
  res => res,
  error => {
    if (error.response?.status === 401) {
      localStorage.clear()
      if (router.currentRoute.value.path !== '/login') {
        router.push({
          name: 'login',
          query: { message: '인증 시간이 만료되었습니다. 다시 로그인해주세요.' }
        })
      }
    }
    return Promise.reject(error)
  }
)

export default api;
